import React, { useCallback, useState } from 'react';

import { useIsGreaterThanTabletLandscape } from '~/src/common/mediaQueries';
import { useIsMobile, useIsTablet } from '~/src/components/hooks';
import { Snackbar } from '~/src/components/Snackbar';
import { fontWeight } from '~/src/styles';

import { FormBody } from './FormBody';
import { SubmittedFormBody } from './SubmittedFormBody';
import { useShowSnackbar } from './useShowSnackbar';

export const SnackbarForm: React.FC = () => {
  const [showSnackbar, setShowSnackbar] = useShowSnackbar();
  const [isFormSubmitted, setIsFormSubmitted] = useState<boolean>(false);
  const onFormSubmitted = useCallback(() => {
    setIsFormSubmitted(true);
  }, []);

  const onClose = useCallback(() => {
    setShowSnackbar(false);
  }, [setShowSnackbar]);

  const isMobile = useIsMobile();
  const isTablet = useIsTablet();
  const isGreaterThanTabletLandscape = useIsGreaterThanTabletLandscape();

  return showSnackbar ? (
    <Snackbar
      headerText={isFormSubmitted ? '' : 'Get Our Most Popular eBook Free:'}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      contentInnerStyle={{ padding: isMobile ? '0px' : isTablet ? '20px 40px' : '20px 80px' }}
      headerStyle={{
        fontSize: '20px',
        letterSpacing: '0.02em',
        lineHeight: '31px',
        fontWeight: fontWeight.regular,
      }}
      style={{
        bottom: 0,
        left: isGreaterThanTabletLandscape ? '50%' : '20px',
        right: isGreaterThanTabletLandscape ? 'auto' : '20px',
        transform: isGreaterThanTabletLandscape ? 'translateX(-50%)' : 'unset',
        width: isGreaterThanTabletLandscape ? '100%' : 'unset',
        maxWidth: isGreaterThanTabletLandscape ? '880px' : 'unset',
        marginLeft: 0,
      }}
      contentStyle={{
        background: '#27292d',
        paddingTop: '20px',
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
      }}
      textAlign="center"
      open={showSnackbar}
      setClose={() => setShowSnackbar(false)}
      variant="white"
      onClose={onClose}
    >
      {isFormSubmitted ? (
        <SubmittedFormBody onClose={onClose} />
      ) : (
        <FormBody onFormSubmitted={onFormSubmitted} />
      )}
    </Snackbar>
  ) : null;
};
